import React from 'react';

const DynamicIcon = ({ strokeColor = 'black', fillColor = 'none', strokeWidth = 1.5, size = 24, path = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d={path}
        stroke={strokeColor}
        fill={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DynamicIcon;